import React, {useContext, useEffect, useState} from "react";
import {
    useLocation
} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import {RuoliContext} from "../../context/RuoliContext";
import {RichiedentiContext} from "../../context/RichiedentiContext";
import axios from "axios";
import {LoaderContext} from "../../context/LoaderContext";
import {CertificatiContext} from "../../context/CertificatiContext";
import MenuAppView from "./MenuAppView";

export default function MenuAppController() {

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [showArchivio, setShowArchivio] = useState(false);
    const [infoPagamento, setInfoPagamento] = useState('');
    const [titoloMsg, setTitoloMsg] = useState('');
    const {user, handleLogout} = useContext(AuthContext);
    const {
        isRuoloAdmin,
        isRuoloSegreteria,
        isRuoloCommissario,
        isRuoloPresidente,
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia
    } = useContext(RuoliContext);
    const {numRichiedenti} = useContext(RichiedentiContext);
    const {numCertificati} = useContext(CertificatiContext);
    const location = useLocation();

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getInfoPagamento() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${user.id_utente}/info-pagamento/`).then((response) => {
            setInfoPagamento(response.data.pagamentiRichiesti)
            endChiamata()
        });
    }

    function checkShowArchivio() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/parametro/?codici=ArchivioVisibile`).then((response) => {
            const parametri = response.data.data;

            if (parametri && parametri.length > 0) {
                const parArchivioVisibile = parametri[0];
                setShowArchivio(parArchivioVisibile.valore == '1');
            }

            endChiamata()
        });
    }

    useEffect(() => {
        if (user) {
            if (isRuoloSocio()) {
                getInfoPagamento()
            }
            checkShowArchivio();
        }
    }, [user, isRuoloSocio()]);

    function showMessage(titolo, testo) {
        setTitoloMsg(titolo);
        setModalMsg(testo);
        setShow(true);
    }

    function hideMessage() {
        setShow(false);
    }

    function showToggle() {
        return location.pathname != '/'
            && location.pathname != '/registrati/1'
            && location.pathname != '/registrati/2'
            && location.pathname.indexOf('/reset-password') !== 0
            && location.pathname.indexOf('/documento-firmato') !== 0;
    }

    function showMenuBarTop() {
        return location.pathname.indexOf('/documento-firmato') !== 0;
    }

    return (
        <MenuAppView
            show={show}
            user={user}
            isRuoloAdmin={isRuoloAdmin}
            isRuoloClub={isRuoloClub}
            isRuoloCommissario={isRuoloCommissario}
            isRuoloSocio={isRuoloSocio}
            isRuoloAgenzia={isRuoloAgenzia}
            isRuoloSegreteria={isRuoloSegreteria}
            isRuoloPresidente={isRuoloPresidente}
            handleLogout={handleLogout}
            hideMessage={hideMessage}
            infoPagamento={infoPagamento}
            modalMsg={modalMsg}
            titoloMsg={titoloMsg}
            numRichiedenti={numRichiedenti}
            showMessage={showMessage}
            numCertificati={numCertificati}
            showToggle={showToggle}
            showMenuBarTop={showMenuBarTop}
            sfondoNero={location.pathname.indexOf('/documento-firmato') === 0}
            showArchivio={showArchivio}
        />
    );
}
